"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var styles = {
  "container": "card-container-11P0y",
  "title": "card-title-2rvi9",
  "description": "card-description-3Qppz"
};

var Card = function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children", "className", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use(styles.container).join(className)
  }, restProps), children);
};

var Title = function Title(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$tag = _ref2.tag,
      Tag = _ref2$tag === void 0 ? 'h1' : _ref2$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["children", "className", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use(styles.title).join(className)
  }, restProps), children);
};

var Description = function Description(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      _ref3$tag = _ref3.tag,
      Tag = _ref3$tag === void 0 ? 'p' : _ref3$tag,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["children", "className", "tag"]);
  return _react.default.createElement(Tag, (0, _extends2.default)({
    className: _utils.classNames.use(styles.description).join(className)
  }, restProps), children);
};

Card.Title = Title;
Card.Description = Description;
var _default = Card;
exports.default = _default;